import { createClearanceRegistry } from './clearanceRegistry'

const bottomActionBars = createClearanceRegistry((element) => element.offsetHeight)

export const useBottomActionBarRef = bottomActionBars.useRef

export const useBottomActionBarClearance = bottomActionBars.useClearance
